import * as THREE from 'three';
import { Base3DPart } from "./base-part";

export class DoorRearTop3DPart extends Base3DPart {
    private model!: THREE.Object3D;
    private mixer!: THREE.AnimationMixer;
    private open = false;
    private v1 = new THREE.Vector3();
    private v2 = new THREE.Vector3();
    private openAction!: THREE.AnimationAction;
    private closeAction!: THREE.AnimationAction;

    override load(scene: THREE.Scene): void {
        const objPath = `${this.basePath}/cover-back-top.gltf`;

        this.gltfLoader.load(objPath, (gltf) => {
            this.model = gltf.scene;
            scene.add(gltf.scene);
            this._createOpenCloseAnimation();
        });
    }

    private _createOpenCloseAnimation(): void {
        this.mixer = new THREE.AnimationMixer(this.model);

        const openKeyframes = [];
        const closeKeyframes = [];

        for (let i = 0; i <= 1; i += 0.01) {
            const angle = THREE.MathUtils.lerp(0, -Math.PI / 2, i);
            const matrix = new THREE.Matrix4()
                .makeTranslation(-this.v1.x, -this.v1.y, -this.v1.z)
                .multiply(new THREE.Matrix4().makeRotationAxis(this.v2.clone().sub(this.v1).normalize(), angle))
                .multiply(new THREE.Matrix4().makeTranslation(this.v1.x, this.v1.y, this.v1.z));

            openKeyframes.push({
                time: i,
                value: matrix.elements
            });

            const closeAngle = THREE.MathUtils.lerp(-Math.PI / 2, 0, i);
            const closeMatrix = new THREE.Matrix4()
                .makeTranslation(-this.v1.x, -this.v1.y, -this.v1.z)
                .multiply(new THREE.Matrix4().makeRotationAxis(this.v2.clone().sub(this.v1).normalize(), closeAngle))
                .multiply(new THREE.Matrix4().makeTranslation(this.v1.x, this.v1.y, this.v1.z));

            closeKeyframes.push({
                time: i,
                value: closeMatrix.elements
            });
        }

        const openTrack = new THREE.KeyframeTrack('.matrix', openKeyframes.map(k => k.time), openKeyframes.flatMap(k => k.value));
        const closeTrack = new THREE.KeyframeTrack('.matrix', closeKeyframes.map(k => k.time), closeKeyframes.flatMap(k => k.value));

        const openClip = new THREE.AnimationClip('open', 1, [openTrack]);
        const closeClip = new THREE.AnimationClip('close', 1, [closeTrack]);

        this.openAction = this.mixer.clipAction(openClip);
        this.closeAction = this.mixer.clipAction(closeClip);
    }

    updateAnimation(delta: number): void {
        this.mixer.update(delta);
    }

    toggleOpen() {
        if (this.open) {
            this.closeAction.reset().play();
        } else {
            this.openAction.reset().play();
        }
        this.open = !this.open;
    }
}